import React from "react";
import File from "./File"
import {DndProvider} from "react-dnd";
import {HTML5Backend} from 'react-dnd-html5-backend';

function FileList(props: { files: any, navigate: any, editFile: any, moveFile: any }) {
  const {files, navigate, editFile, moveFile} = props;

  if (files.length === 0) {
    return null;
  }

  const fileComponents = files.map((file: any, index: number) => {
      return <File file={file}
                   index={index}
                   key={`file-${file.id}`}
                   navigate={navigate}
                   editFile={editFile}
                   moveFile={moveFile}
      />;
    }
  );

  return (
    <DndProvider backend={HTML5Backend}>
      {fileComponents}
    </DndProvider>
  );
}

export default FileList;
